@if (!appSettings.isMobile()) {
  <div class="request-list-desktop">
    <div class="mb-2">
      <input type="text"
             class="form-control form-control-sm py-2"
             placeholder="Buscar socio, RUT, patente, folio..."
             [ngModel]="searchQuery()"
             (ngModelChange)="searchQuery.set($event)">
    </div>

    <div class="badges-scroll-container mb-2">
      <ng-container *ngTemplateOutlet="typeFilterBadges"></ng-container>
    </div>

    <div class="request-cards-scroll desktop-cards-scroll">
      <ng-container *ngTemplateOutlet="requestCards"></ng-container>
    </div>
    <div class="pt-2 text-center text-muted small">
      Total Registros: {{ requests()?.length || 0 }}
    </div>
  </div>
} @else {
  <div class="mobile-requests-container">
    <div class="badges-scroll-container mb-2">
      <ng-container *ngTemplateOutlet="typeFilterBadges"></ng-container>
    </div>

    <div class="d-flex justify-content-between align-items-center mb-2 px-1">
      <span class="small text-muted fw-bold text-uppercase">
        REGISTROS @if (!isLoading()) { ({{ requests()?.length || 0 }}) }
      </span>
    </div>

    <div class="request-cards-scroll mobile-cards-scroll">
      <ng-container *ngTemplateOutlet="requestCards"></ng-container>
    </div>
  </div>
}

<ng-template #typeFilterBadges>
  @for (filter of typeFilters(); track filter.slug) {
    <span class="filter-badge"
          role="button"
          tabindex="0"
          [class.active]="activeTypeFilter() === filter.slug"
          (click)="toggleTypeFilter(filter.slug)"
          (keydown.enter)="toggleTypeFilter(filter.slug)"
          (keydown.space)="toggleTypeFilter(filter.slug)">
      @if (activeTypeFilter() === filter.slug) {
        <i class="{{ filter.icon }} me-1"></i>
      }
      {{ filter.name }}
    </span>
  }
</ng-template>

<ng-template #requestCards>
  @if (isLoading()) {
    @for (i of [1, 2, 3, 4, 5]; track $index) {
      <app-list-card [isLoading]="true"></app-list-card>
    }
  } @else {
    @for (app of requests(); track app.uuid) {
      <app-list-card
        [isShortcut]="appSettings.isMobile()"
        [customClass]="selectedUuid() === app.uuid ? 'list-card-selected' : ''"
        (click)="onSelectRequest(app)">
        <div cardTitle class="fw-bold text-dark text-truncate">
          @if (app.processSlug === 'PAYMENT') {
            {{ getEntityCampus(app.entityCode) }}
          } @else {
            {{ app.party?.names }} {{ app.party?.lastNames }}
          }
        </div>

        <div cardBadge class="d-flex gap-1">
          @if (app.entityCode) {
            <span class="badge bg-secondary">{{ app.entityCode }}</span>
          }
        </div>

        <div class="text-muted small text-truncate">
          @if (app.vehicle?.plate || app.claim?.vehicle?.plate) {
            <i class="fa fa-car me-1"></i>{{ app.vehicle?.plate ?? app.claim?.vehicle?.plate }}
            <span class="mx-1">·</span>
          }
          <i [ngClass]="app.process.icon" class="me-1"></i>{{ app.process.name }}
          <span class="mx-1">·</span>
          <i class="fa fa-calendar me-1"></i>{{ app.createdAt | date:'dd/MM/yyyy' }}
        </div>

        <span cardExtra class="text-uppercase fw-semibold text-muted" style="font-size: 0.75rem; letter-spacing: 0.5px;">
          ESTADO
        </span>
        <div cardAmount>
          @if (hasObservedEvidence(app)) {
            <span class="badge border border-warning text-warning">Observado</span>
          } @else {
            <span class="badge border" [ngClass]="app?.statusObj?.style">
              {{ app.statusObj?.name || app.statusSlug }}
            </span>
          }
        </div>
      </app-list-card>
    }
  }

  @if (!isLoading() && !requests()?.length) {
    <div class="card border-0 shadow-sm p-4 text-center my-2">
      <i class="fas fa-clipboard-check fa-3x text-muted opacity-50 mb-2"></i>
      <h6 class="text-muted mb-1">No hay solicitudes pendientes</h6>
      <small class="text-muted">Ajusta los filtros para ver más resultados.</small>
    </div>
  }
</ng-template>
